(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sockpet-size-finder"] && !Shopify.designMode) return;
  try {
    (() => {
  const CM_PER_INCH = 2.54;
  const copy = {
    en: {
      eyebrow: 'Product-specific fit', title: 'Find my fit', required: 'Required',
      chestHint: 'Measure around the widest point behind the front legs.',
      backHint: 'Measure from the base of the neck to the base of the tail.',
      neckHint: 'Measure where the collar naturally sits.', fitPreference: 'Fit preference',
      regular: 'Regular fit', relaxed: 'Relaxed fit', submit: 'Find my size', recommended: 'Recommended size',
      again: 'Measure again', chart: 'View product size chart',
      manual: 'Manual flat measurement. Please allow a 1–2 cm difference.',
      chestRequired: 'Please enter a valid Chest measurement.', high: 'High match', medium: 'Check fit', low: 'Reference only',
      resultTitle: size => `Size ${size} recommended`,
      matched: count => `${count} measurement${count === 1 ? '' : 's'} match this product’s size range.`,
      mismatch: 'Some measurements are outside this size range.',
      boundary: (a, b) => `Your measurements are close to the ${a} / ${b} boundary. Choose the larger size for thick fur, growth, or a relaxed fit.`,
      missing: 'Add the remaining measurement for a more reliable recommendation.',
      noMatch: 'No size covers all entered measurements. Remeasure or contact support before ordering.',
      size: 'Size', chest: 'Chest', back: 'Back', neck: 'Neck'
    },
    zh: {
      eyebrow: '商品专属尺码', title: '帮我选尺码', required: '必填',
      chestHint: '测量前腿后方最宽处的胸围。', backHint: '从颈根量至尾根。', neckHint: '测量日常佩戴项圈的位置。',
      fitPreference: '穿着偏好', regular: '日常合身', relaxed: '宽松舒适', submit: '推荐我的尺码', recommended: '推荐尺码',
      again: '重新测量', chart: '查看商品尺码表', manual: '手工平铺测量可能存在 1–2 cm 误差。',
      chestRequired: '请填写有效的 Chest（胸围）数据。', high: '高匹配', medium: '需留意', low: '仅供参考',
      resultTitle: size => `推荐 ${size} 码`, matched: count => `${count} 项尺寸与商品尺码范围匹配。`,
      mismatch: '部分数据超出该尺码范围。', boundary: (a, b) => `数据接近 ${a} / ${b} 临界值。毛量较多、仍在生长期或喜欢宽松穿着时，建议选择较大尺码。`,
      missing: '补充其余测量数据可提高推荐可靠度。', noMatch: '没有尺码能覆盖全部输入数据，请复测或联系客服确认。',
      size: '尺码', chest: '胸围', back: '背长', neck: '颈围'
    }
  };

  const localeOf = root => String(root.dataset.locale || 'en').toLowerCase().startsWith('zh') ? 'zh' : 'en';
  const q = (root, selector) => root.querySelector(selector);
  const qa = (root, selector) => [...root.querySelectorAll(selector)];
  const fromCm = (value, unit) => unit === 'cm' ? value : value / CM_PER_INCH;
  const format = (value, unit) => Number(fromCm(value, unit).toFixed(unit === 'cm' ? 0 : 1));
  const metricScore = (value, range, weight) => {
    if (value == null || !Array.isArray(range)) return { score: 0, inside: null, distance: Infinity };
    const [min, max] = range;
    const width = Math.max(max - min, 1);
    if (value >= min && value <= max) {
      return { score: Math.abs(value - (min + max) / 2) / width * weight, inside: true, distance: Math.min(value - min, max - value) };
    }
    const gap = value < min ? min - value : value - max;
    return { score: (1.5 + gap / width * 3) * weight, inside: false, distance: -gap };
  };

  const sizeToken = value => String(value).trim().toUpperCase().match(/^(XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|[2-9]XL)(?=$|[^A-Z])/u)?.[0]?.replace(/^XXL$/, '2XL').replace(/^XXXL$/, '3XL');
  const validRange = r => Array.isArray(r) && r.length === 2 && r.every(n => Number.isFinite(n) && n > 0) && r[0] <= r[1];
  const profileFor = (payload, selected) => {
    if (!Array.isArray(payload?.profiles)) return { sizes: Array.isArray(payload) ? payload : payload?.sizes };
    const matches = payload.profiles.filter(p => p.match && Object.entries(p.match).every(([name, values]) => (Array.isArray(values) ? values : [values]).includes(selected[name])));
    return matches.length === 1 && !matches[0].disabled ? matches[0] : null;
  };
  const variantFor = (variants, optionNames, selected, sizeIndex, row) => {
    const styleMatches = variants.filter(v => optionNames.every((name, i) => i === sizeIndex || v.options[i] === selected[name]));
    const explicit = row.option_value;
    let found = styleMatches.filter(v => v.options[sizeIndex] === (explicit || row.size));
    if (!found.length && !explicit) {
      found = styleMatches.filter(v => sizeToken(v.options[sizeIndex]) && sizeToken(v.options[sizeIndex]) === sizeToken(row.size));
      if (found.length > 1 && Number.isFinite(row.original?.chest)) found = found.filter(v => {
        const chest = v.options[sizeIndex].match(/(?:chest|bust|胸围)\s*(\d+(?:\.\d+)?)/i);
        return chest && Number(chest[1]) === row.original.chest;
      });
    }
    return found.length === 1 ? found[0] : null;
  };

  function init(root) {
    const lang = localeOf(root);
    const t = (key, ...args) => typeof copy[lang][key] === 'function' ? copy[lang][key](...args) : copy[lang][key];
    let payload;
    try { payload = JSON.parse(q(root, '[data-size-chart-json]').textContent); } catch (_) { return; }
    const productData = JSON.parse(q(root, '[data-fit-product]').textContent);
    const messages = JSON.parse(q(root, '[data-fit-translations]').textContent);
    const resultMessages = JSON.parse(q(root, '[data-fit-result-translations]').textContent);
    const optionNames = productData.options;
    const sizeIndex = optionNames.findIndex(name => /^(size|sizes|尺码|尺寸)$/i.test(name.trim()));
    const scope = root.closest('product-info') || root.closest('.shopify-section');
    const getPicker = () => scope?.querySelector('variant-selects');
    const selection = () => {
      const picker = getPicker();
      const selected = {};
      picker?.querySelectorAll('fieldset, .product-form__input--dropdown').forEach(group => {
        const element = group.querySelector('input:checked') || group.querySelector('select')?.selectedOptions[0];
        if (element) selected[element.dataset.optionName] = element.value;
      });
      return selected;
    };
    const styleKey = selected => JSON.stringify(optionNames.filter((_, i) => i !== sizeIndex).map(name => selected[name]));
    let sizes = [], supported = [], primary = 'chest', resultStyle = '', busy = false;
    let unit = 'cm';
    let lastResult = null;
    const dialog = q(root, '[data-fit-dialog]');
    const form = q(root, '[data-fit-form]');
    const resultEl = q(root, '[data-fit-result]');
    const apply = q(root, '[data-fit-apply]');
    const status = q(root, '[data-fit-apply-status]');
    const refreshProfile = () => {
      const selected = selection();
      let profile = profileFor(payload, selected);
      if (!payload.profiles && ['15835710423113', '15835713896521', '15835713142857'].includes(root.dataset.productId)) profile = null;
      sizes = profile?.sizes || [];
      supported = ['chest', 'back', 'neck'].filter(metric => sizes.length && sizes.every(row => validRange(row[metric])));
      primary = supported.includes('chest') ? 'chest' : supported.includes('neck') ? 'neck' : 'back';
      const valid = sizes.length > 0 && supported.length > 0 && sizes.every(row => row.size) && sizeIndex >= 0;
      q(root, '[data-fit-style]').textContent = optionNames.filter((_, i) => i !== sizeIndex).map(name => selected[name] || '').filter(Boolean).join(' / ');
      qa(root, '[data-field]').forEach(field => {
        field.hidden = !supported.includes(field.dataset.field);
        field.querySelector('input').required = field.dataset.field === primary;
        const badge = field.querySelector('em');
        if (badge) badge.hidden = field.dataset.field !== primary;
      });
      q(root, '[data-fit-form] button[type="submit"]').disabled = !valid;
      q(root, '[data-fit-error]').textContent = valid ? '' : messages.missing;
      return valid;
    };

    qa(root, '[data-copy]').forEach(node => { node.textContent = t(node.dataset.copy); });
    qa(root, '[data-field]').forEach(field => { field.hidden = !supported.includes(field.dataset.field); });

    const renderTable = recommended => {
      const table = q(root, '[data-fit-table]');
      const head = `<thead><tr><th>${t('size')}</th>${supported.map(m => `<th>${t(m)}</th>`).join('')}</tr></thead>`;
      const body = sizes.map(row => {
        const cells = supported.map(metric => {
          const source = row.original?.[metric];
          if (source == null) return '<td>—</td>';
          const values = Array.isArray(source) ? source : [source];
          return `<td>${values.map(v => format(v, unit)).join('–')} ${unit === 'cm' ? 'cm' : 'in'}</td>`;
        }).join('');
        return `<tr${row.size === recommended ? ' class="is-recommended"' : ''}><th>${row.size}</th>${cells}</tr>`;
      }).join('');
      table.innerHTML = head + `<tbody>${body}</tbody>`;
    };

    const read = () => Object.fromEntries(supported.map(metric => {
      const input = q(root, `[name="${metric}"]`);
      const number = Number(input.value);
      return [metric, input.value.trim() && Number.isFinite(number) && number > 0 ? (unit === 'cm' ? number : number * CM_PER_INCH) : null];
    }));

    const recommend = (measurements, preference) => {
      const entered = supported.filter(metric => measurements[metric] != null);
      const weights = { chest: 1.6, back: 1, neck: .8 };
      const ranked = sizes.map((row, index) => {
        const details = {}; let score = 0;
        entered.forEach(metric => {
          details[metric] = metricScore(measurements[metric], row[metric], weights[metric]);
          score += details[metric].score;
        });
        const misses = Object.values(details).filter(d => d.inside === false).length;
        if (preference === 'relaxed') score -= index * .025;
        return { row, index, score, details, misses };
      }).sort((a, b) => Number(a.misses > 0) - Number(b.misses > 0) || a.score - b.score || (preference === 'relaxed' ? b.index - a.index : a.index - b.index));
      const best = ranked[0], next = ranked[1];
      const nearBoundary = best.details[primary]?.inside && best.details[primary].distance <= 0.6;
      const closeAlternative = next && Math.abs(next.score - best.score) < .7;
      const missing = supported.filter(metric => measurements[metric] == null).length;
      const level = best.misses ? 'low' : (missing || nearBoundary || closeAlternative ? 'medium' : 'high');
      let notice = missing ? t('missing') : '';
      if ((nearBoundary || closeAlternative) && next) notice = t('boundary', best.row.size, next.row.size);
      if (best.misses) notice = t('noMatch');
      return { ...best, level, notice, measurements, entered };
    };

    const renderResult = result => {
      const unmatched = result.misses > 0;
      const incomplete = result.entered.length < supported.length;
      resultEl.classList.toggle('is-unmatched', unmatched);
      q(root, '[data-fit-badge]').textContent = unmatched ? resultMessages.no_size : t(result.level);
      q(root, '[data-fit-size]').hidden = unmatched;
      q(root, '[data-fit-size]').textContent = unmatched ? '' : result.row.size;
      q(root, '[data-copy="recommended"]').hidden = unmatched;
      q(root, '[data-fit-title]').textContent = unmatched ? resultMessages.no_size : incomplete ? resultMessages.incomplete : t('resultTitle', result.row.size);
      q(root, '[data-fit-summary]').textContent = unmatched ? t('noMatch') : t('matched', result.entered.length);
      const notice = q(root, '[data-fit-notice]');
      notice.textContent = unmatched ? '' : result.notice;
      notice.hidden = unmatched || !result.notice;
      const comparison = q(root, '[data-fit-comparison]');
      comparison.replaceChildren();
      comparison.hidden = !unmatched;
      if (unmatched) {
        const heading = document.createElement('strong');
        heading.textContent = resultMessages.compare;
        comparison.append(heading);
        const list = document.createElement('ul');
        const unitLabel = unit === 'cm' ? 'cm' : 'in';
        sizes.forEach(row => {
          const conflicts = result.entered.filter(metric => result.measurements[metric] < row[metric][0] || result.measurements[metric] > row[metric][1]);
          const item = document.createElement('li');
          item.textContent = row.size + ': ' + conflicts.map(metric => `${t(metric)} — ${resultMessages.entered} ${format(result.measurements[metric], unit)} ${unitLabel}; ${resultMessages.range} ${row[metric].map(n => format(n, unit)).join('–')} ${unitLabel}`).join('; ');
          list.append(item);
        });
        comparison.append(list);
      }
      form.hidden = true;
      resultEl.hidden = false;
      lastResult = result;
      resultStyle = styleKey(selection());
      const variant = variantFor(productData.variants, optionNames, selection(), sizeIndex, result.row);
      apply.disabled = Boolean(result.misses || !variant?.available || result.entered.length < supported.length);
      apply.hidden = unmatched;
      status.textContent = unmatched ? '' : incomplete ? t('missing') : !variant?.available ? messages.unavailable : '';
      renderTable(unmatched ? undefined : result.row.size);
    };

    q(root, '[data-fit-open]').addEventListener('click', () => {
      refreshProfile();
      form.hidden = false;
      resultEl.hidden = true;
      lastResult = null;
      renderTable();
      dialog.showModal();
    });
    q(root, '[data-fit-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!refreshProfile()) return;
      const measurements = read();
      if (measurements[primary] == null) {
        q(root, '[data-fit-error]').textContent = messages.required;
        q(root, `[name="${primary}"]`).focus();
        return;
      }
      q(root, '[data-fit-error]').textContent = '';
      renderResult(recommend(measurements, q(root, '[name="preference"]').value));
    });
    apply.addEventListener('click', async () => {
      if (busy || !lastResult || apply.disabled) return;
      if (styleKey(selection()) !== resultStyle) { status.textContent = messages.changed; apply.disabled = true; return; }
      const variant = variantFor(productData.variants, optionNames, selection(), sizeIndex, lastResult.row);
      if (!variant?.available || lastResult.misses) { status.textContent = messages.unavailable; apply.disabled = true; return; }
      const picker = getPicker();
      const targets = [...(picker?.querySelectorAll('input[type="radio"], select option') || [])].filter(el => el.dataset.optionName === optionNames[sizeIndex] && el.value === variant.options[sizeIndex]);
      if (targets.length !== 1) { status.textContent = messages.failed; return; }
      const target = targets[0];
      busy = true; apply.disabled = true; apply.textContent = messages.working;
      try {
        const control = target.tagName === 'OPTION' ? target.closest('select') : target;
        if (target.tagName === 'OPTION') control.value = target.value; else target.checked = true;
        control.dispatchEvent(new Event('change', { bubbles: true }));
        const selected = await new Promise((resolve, reject) => {
          const started = Date.now();
          const check = () => {
            if (!root.isConnected || styleKey(selection()) !== resultStyle) return reject(new Error('changed'));
            const input = scope.querySelector('product-form input[name="id"]');
            const submit = scope.querySelector('product-form button[type="submit"]');
            if (String(input?.value) === String(variant.id) && submit && !submit.disabled) return resolve(true);
            if (Date.now() - started > 8000) return reject(new Error('timeout'));
            setTimeout(check, 100);
          };
          check();
        });
        if (selected) { dialog.close(); getPicker()?.querySelector('input:checked, select')?.focus(); }
      } catch (_) { status.textContent = messages.failed; }
      finally { busy = false; apply.textContent = messages.apply; apply.disabled = false; }
    });
    scope?.addEventListener('change', event => {
      if (!event.target.closest('variant-selects') || busy || !lastResult) return;
      lastResult = null; apply.disabled = true; resultEl.hidden = true; form.hidden = false;
      refreshProfile(); renderTable();
    });
    q(root, '[data-fit-again]').addEventListener('click', () => {
      resultEl.hidden = true;
      form.hidden = false;
      lastResult = null;
      renderTable();
    });
    qa(root, '[data-unit]').forEach(button => button.addEventListener('click', () => {
      const next = button.dataset.unit;
      if (next === unit) return;
      supported.forEach(metric => {
        const input = q(root, `[name="${metric}"]`);
        if (input.value) input.value = next === 'in' ? (Number(input.value) / CM_PER_INCH).toFixed(1) : (Number(input.value) * CM_PER_INCH).toFixed(1);
      });
      unit = next;
      qa(root, '[data-unit]').forEach(b => {
        b.classList.toggle('is-active', b.dataset.unit === unit);
        b.setAttribute('aria-pressed', b.dataset.unit === unit);
      });
      qa(root, '[data-unit-label]').forEach(label => { label.textContent = unit === 'cm' ? 'cm' : 'in'; });
      if (lastResult) renderResult(lastResult); else renderTable();
    }));
    refreshProfile();
    renderTable();
  }

  const mount = scope => scope.querySelectorAll('[data-sockpet-size-finder]').forEach(root => {
    if (!root.dataset.ready) { root.dataset.ready = 'true'; init(root); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document)); else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
